import { createFileRoute, Outlet } from "@tanstack/react-router";
import ToolsNav from "../components/layout/ToolsNav";

export const Route = createFileRoute("/_tools")({
  component: ToolsLayout,
});

function ToolsLayout() {
  return (
    <div className="flex justify-center pt-4 overflow-x-hidden">
      <aside className="static transition-all w-12 lg:w-50 mr-2 shrink-0">
        <div className="flex flex-col h-full">
          <div className="flex-1 overflow-y-auto">
            <ToolsNav />
          </div>
        </div>
      </aside>
      <div className="flex w-full max-w-7xl min-w-0">
        <main className="flex-1 bg-background">
          <div className="h-full w-full overflow-y-auto px-2">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
